
import initialStateHotel from './initialState'

const getters = {
  getHotels: state => state.hotels,
  getHotelForm: state => (hotelIndex) => {
    const result = {
      ...state.hotels[hotelIndex].form,
      filters: state.hotels[hotelIndex].filters,
    }
    const rooms = result.rooms

    if (!Array.isArray(rooms)) {
      result.rooms = Object.keys(rooms).map(key => rooms[key])
    }

    return result
  },
  // eslint-disable-next-line
  getHotelFormForSearch: (state, getters) => hotelIndex => ({
    ...getters.getHotelForm(hotelIndex),
    currency: getters.getCartPrice.currency
  }),
  getHotelAccommodations: state => hotelIndex => (
    state.hotels.length
      ? state.hotels[hotelIndex].accommodations
      : initialStateHotel().accommodations
  ),
  getHotelTariffConditions: state => hotelIndex => state.hotels[hotelIndex].tariffConditions,
  getHotelFilters: state => hotelIndex => state.hotels[hotelIndex].collectionFilters
}

export default getters